import { SDK_DOMAIN } from '../../constants';
import { setAddEventListener } from '../../helpers';

const ResultPage = {
  state: {},
  render: async () => {
    const state = history.state;

    return `
      <div>
          <a id="connect_pay_back_button" class="c_back"></a>
      </div>
      <div class="c_title1">${state.title || '커넥트페이 오류'}</div>
      
      <div class="c_result_icon m_b_20"><img src="${SDK_DOMAIN}/images/icon-${
      state.type || 'fail'
    }.png" /></div>
      <div class="c_label4_4 m_b_20 text_center">${state.message}</div>
      
      <div class="bottom_btn_wrapper">
          <button id="ok_btn" class="btn c_btn1 skin1_btn">확인</button>
      </div>
    `;
  },
  afterRender: async () => {
    setAddEventListener('connect_pay_back_button', () => {
      history.back();
    });
    setAddEventListener('ok_btn', () => {
      history.back();
    });
  },
};
export default ResultPage;
